import type {
  AuthResponse,
  ChangePasswordInput,
  ForgotPasswordInput,
  LoginResponse,
  RegenerateRecoveryCodesInput,
  ResetPasswordInput,
  TwoFactorChallengeInput,
  TwoFactorDisableInput,
  TwoFactorSetupResponse,
  TwoFactorStatusDTO,
  TwoFactorVerifyInput,
  TwoFactorVerifyResponse,
} from '@bruno/shared';
import { api, setAccessToken } from './client';

export function changePassword(body: ChangePasswordInput): Promise<void> {
  return api<void>('/v1/account/password', { method: 'POST', body });
}

export function getTwoFactorStatus(): Promise<TwoFactorStatusDTO> {
  return api<TwoFactorStatusDTO>('/v1/account/2fa/status');
}

export function setupTwoFactor(): Promise<TwoFactorSetupResponse> {
  return api<TwoFactorSetupResponse>('/v1/account/2fa/setup', { method: 'POST' });
}

export function verifyTwoFactor(body: TwoFactorVerifyInput): Promise<TwoFactorVerifyResponse> {
  return api<TwoFactorVerifyResponse>('/v1/account/2fa/verify', { method: 'POST', body });
}

export function disableTwoFactor(body: TwoFactorDisableInput): Promise<void> {
  return api<void>('/v1/account/2fa/disable', { method: 'POST', body });
}

export function regenerateRecoveryCodes(
  body: RegenerateRecoveryCodesInput,
): Promise<TwoFactorVerifyResponse> {
  return api<TwoFactorVerifyResponse>('/v1/account/2fa/recovery-codes', {
    method: 'POST',
    body,
  });
}

export function forgotPassword(body: ForgotPasswordInput): Promise<void> {
  return api<void>('/v1/auth/forgot-password', {
    method: 'POST',
    body,
    retryOn401: false,
  });
}

export function resetPassword(body: ResetPasswordInput): Promise<void> {
  return api<void>('/v1/auth/reset-password', {
    method: 'POST',
    body,
    retryOn401: false,
  });
}

export async function twoFactorLogin(body: TwoFactorChallengeInput): Promise<AuthResponse> {
  const res = await api<LoginResponse>('/v1/auth/2fa/login', {
    method: 'POST',
    body,
    retryOn401: false,
  });
  if ('requires2fa' in res) {
    throw new Error('Unexpected 2FA challenge from /2fa/login');
  }
  setAccessToken(res.accessToken);
  return res;
}
